<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/store/api'
import exportFromJSON from 'export-from-json'
import { timestampFileSystemCompatible } from '../../lib/misc'

export default {
  name: 'SearchLogsExport',
  computed: {
    ...mapGetters('searchLogs', { getFilters: 'getFilters' }),
    exportQueryString() {
      const filters = this.getFilters.filter(
        (f) => f.key !== 'pageSize' && f.key !== 'pageNumber'
      )
      const parts = filters.map((f) => `${f.key}=${encodeURIComponent(f.value)}`)
      parts.push('pageSize=1000000')
      parts.push('pageNumber=1')
      return '?' + parts.join('&')
    },
  },
  methods: {
    async exportData() {
      const resource = 'searchLogs'
      const {
        data: { data },
      } = await api.get(`/${resource}${this.exportQueryString}`)
      const dataToExport = data.map((row) => {
        return {
          ID: row.id,
          'Sökfråga': row.user_query,
          'Innehållstyp': row.content_type,
          'Lyckades': row.success ? 'Ja' : 'Nej',
          'Fel': row.error || '',
          'Skapad': row.created_at,
        }
      })
      const fileName = `sokningar-export-${timestampFileSystemCompatible()}`
      exportFromJSON({ data: dataToExport, fileName, exportType: exportFromJSON.types.xls })
      this.$router.replace({ name: 'SearchLogs' })
    },
  },
  created() {
    this.exportData()
  },
}
</script>
